import axios from 'axios'
import {getApiUrls,getApiUpdateUrls} from "@/http/base.http";

export function getDeviceType(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}device/type/get`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function addDeviceType(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}device/type/add`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function getByDeviceType(id) {
    const { env } = getApiUrls();
    return axios.get(`${env}device/type/detail/${id}`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function updateDeviceType(payload) {
    const {envU } = getApiUpdateUrls();
    return axios.put(`${envU}device/type/update`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}